<!--
* @Name：议价审批物料信息明细
* @Author: 刘玉
* @Date: 2021-12-02 15:43:31
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:31
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.bargainItemId" :row-index="index + 1">
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row>
        <span>公司：</span>
        <span>{{ getCropName(item.corpId) }}</span>
      </van-row>
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>单价：</span>
        <span>{{ item.unitPrice }}</span>
      </van-row>
      <van-row>
        <span>税率：</span>
        <span>{{ item.taxRate }}</span>
      </van-row>
      <van-row>
        <van-button type="info" size="normal" @click="viewDetailsInfo(item)">详细信息</van-button>
      </van-row>
    </hi-card>
    <details-info
      v-if="detailsVisible"
      :details-visible="detailsVisible"
      :history-price-list="historyPriceList"
      :details-info="detailsInfo"
      @close-details-dialog="detailsVisible = false"
    />
  </div>
</template>

<script>
import { getStruCrop } from '@/api/bargain.js'
export default {
  name: 'MaterialDetails',
  components: {
    'details-info': () => import('./DetailsInfo')
  },
  data() {
    return {
      cropOptions: [],
      detailsInfo: {},
      detailsVisible: false
    }
  },
  props: {
    historyPriceList: {
      type: Array,
      default: () => []
    },
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.initCropOptions()
  },
  methods: {
    async initCropOptions() {
      console.log(this.detailsList)
      const response = await getStruCrop()
      this.cropOptions = response.data
    },
    getCropName(corpId) {
      console.log(corpId)
      if (!this.cropOptions || !this.cropOptions.length) return corpId
      const data = this.cropOptions.find(item => item.corpId === corpId)
      if (!data) return corpId
      return data.corpFullName
    },
    viewDetailsInfo(item) {
      this.detailsInfo = item
      this.detailsVisible = true
    }
  }
}
</script>
